import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { api, DOMAIN_COLORS } from "@/lib/api";

export default function SampleReport() {
  const [report, setReport] = useState(null);
  useEffect(() => { api.get("/public/sample-report").then((r) => setReport(r.data)).catch(() => {}); }, []);

  if (!report) return <Layout><div className="container-msis py-20">Loading sample report…</div></Layout>;

  return (
    <Layout>
      <section className="container-msis py-12">
        <div className="overline mb-2">Sample Report — Dummy Data</div>
        <h1 className="font-display font-bold text-3xl sm:text-4xl tracking-tighter">MSIS Respondent Report</h1>
        <p className="text-sm text-slate2 mt-2 max-w-2xl">This is a demonstration of the auto-generated respondent report. Actual reports use the test taker's own responses.</p>

        <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-border">
          {[
            ["Respondent Name", report.respondent.name],
            ["Test ID", report.respondent.test_id],
            ["Institution", report.respondent.institution_code || "Individual"],
            ["Assessment Date", report.assessment_date],
          ].map(([k, v]) => (
            <div key={k} className="bg-white p-4">
              <div className="overline">{k}</div>
              <div className="font-display font-bold text-sm mt-1">{v}</div>
            </div>
          ))}
        </div>

        <h2 className="font-display font-bold text-2xl mt-12 mb-4">Domain Ranking</h2>
        <div className="border border-border rounded-md overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-navy text-white text-xs uppercase tracking-wider">
              <tr>
                <th className="text-left p-3 w-12">Rank</th>
                <th className="text-left p-3 w-20">Code</th>
                <th className="text-left p-3">Specialization Domain</th>
                <th className="text-right p-3 w-24">Score</th>
                <th className="text-left p-3 w-44">Inclination</th>
              </tr>
            </thead>
            <tbody>
              {report.domain_ranking.map((d, i) => (
                <tr key={d.code} className="border-t border-border">
                  <td className="p-3 font-mono">{i + 1}</td>
                  <td className="p-3 font-mono"><span style={{ color: DOMAIN_COLORS[d.code] }}>{d.code}</span></td>
                  <td className="p-3">{d.name}</td>
                  <td className="p-3 text-right font-mono font-bold">{d.score.toFixed(2)}</td>
                  <td className="p-3 text-slate2">{d.band_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <h2 className="font-display font-bold text-2xl mt-12 mb-4">Detailed Profile</h2>
        <div className="space-y-8">
          {report.domain_ranking.map((d, i) => (
            <article key={d.code} className="border border-border rounded-md p-6">
              <div className="flex items-center justify-between gap-3 flex-wrap">
                <div className="flex items-center gap-3">
                  <span className="font-mono text-xs px-2 py-1 border" style={{ borderColor: DOMAIN_COLORS[d.code] + "55", color: DOMAIN_COLORS[d.code] }}>{d.code}</span>
                  <span className="overline">Rank {i + 1}</span>
                </div>
                <div className="font-mono text-sm">{d.score.toFixed(2)} · {d.band_name}</div>
              </div>
              <h3 className="font-display font-bold text-xl mt-3">{d.name}</h3>
              <p className="text-sm text-slate2 mt-2 leading-relaxed">{d.interpretation}</p>

              <div className="mt-5 grid sm:grid-cols-2 gap-px bg-border">
                {d.constructs.map((c) => (
                  <div key={c.code} className="bg-white p-4">
                    <div className="flex items-center justify-between gap-3">
                      <div className="font-mono text-[11px] text-slate2">{c.code}</div>
                      <div className="font-mono text-sm font-bold">{c.score.toFixed(2)}</div>
                    </div>
                    <div className="font-display font-semibold mt-1">{c.name}</div>
                    <div className="text-xs text-slate2 mt-1">{c.band_name}</div>
                    <div className="h-1 mt-2 bg-subtle rounded">
                      <div className="h-full" style={{ width: `${(c.score / 5) * 100}%`, background: DOMAIN_COLORS[d.code] }} />
                    </div>
                  </div>
                ))}
              </div>
            </article>
          ))}
        </div>
      </section>
    </Layout>
  );
}
